import React from "react";
import PropTypes from "prop-types";

// import store
import { connect } from "react-redux";

// import deep-equal
import equal from "deep-equal";

// import store actions
import {
  setAppTokenAsked,
  setAppTokenRetrieved,
  setCountry,
  setSchool,
  togglePreloader,
} from "../../store/actions";

// import services
import { getCountry, getCountryArticles } from "../../services/countryService";
import {
  getSchools,
  getCountrySchool,
  addUniversityInStudentFavoriteList,
} from "../../services/schoolService";

// import dummies
import { COUNTRY } from "../../helpers/dummies";

// import common components
import Banner from "../../components/common/Banner";
import Carousels from "../../components/common/Carousels";
import Leading from "../../components/common/Leading";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Section from "../../components/common/Section";
import Sliders, { RESPONSIVES } from "../../components/common/Sliders";
import Aambassador from "../../components/custom/countries/Aambassador";

// import custom components
import TabsCountry from "../../components/custom/countries/TabsCountry";
import FilterSchool from "../../components/custom/schools/FilterSchool";
import ListSchool from "../../components/custom/schools/ListSchool";

// import constants
import { COUNTRY_TABS, APP_TOKEN,USER_DATA } from "../../helpers/constants";
import { isUnauthenticatedRequest } from "../../helpers/utilities";
import Presentation from "../../components/custom/countries/Presentation";

// import assets
import ads from "../../assets/images/ads.png";
import ArticlesCountry from "../../components/custom/countries/Articles";
import { article, school } from "../../assets/images";
import country_banner from "../../assets/fonts/country_banner.svg";

// custom sliders options
const SLIDERS_RESPONSIVES = {
  ...RESPONSIVES,
  desktop: { ...RESPONSIVES.desktop, items: 4 },
  tablet: { ...RESPONSIVES.tablet, items: 2 },
};

class Country extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isUnmounted: false,
      articles: [],
      userPublicId: "",
      isShareModalOpen:false
      // userDetails:{}
    };
    this.addUniversitytoFavorites = this.addUniversitytoFavorites.bind(this);
    this.handleShareModalOpen = this.handleShareModalOpen.bind(this);
    this.handleShareModalClose = this.handleShareModalClose.bind(this);
  }

  componentDidMount() {
    try {
      let user = JSON.parse(localStorage.getItem(USER_DATA));
      console.log("=||||||||||||||",{user})
      this.setState({
        userPublicId:user.publicId
      })
      // Load country
      this.props.onPreloaderToggled(true, "Chargement du pays");
      this.onGetCountry();
    } catch (error) {
      console.log(error);
    }
    this.setState({ isUnmounted: false });
  }

  componentDidUpdate(prevProps) {
    try {
      //Check props
      if (!equal(prevProps, this.props)) {
        if (this.props.tokenRetrieved && localStorage.getItem(APP_TOKEN)) {
          this.props.onAppTokenRetrieved(false);
          this.onGetCountry();
        } else if (this.props.tokenFailed) {
          this.props.onPreloaderToggled(false, "");
        }
        this.onGetSchools();
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentWillUnmount() {
    this.props.onSetCountry({});
    this.setState({ isUnmounted: true });
  }

  /**
   * Get country.
   *
   */
  onGetCountry() {
    let { countryCode } = this.props.match.params;
    console.log(countryCode);
    getCountry(countryCode)
      .then((response) => {
        if (
          response &&
          response.publicId &&
          response.publicId === countryCode
        ) {
          this.props.onSetCountry({
            ...response,
            code: response.code ? response.code : COUNTRY.code,
            image: response.image ? response.image : COUNTRY.image,
            sliders: response.sliders ? response.sliders : COUNTRY.sliders,
          });
          this.onGetSchools();
          this.onGetCountryArticles(countryCode);
        } else if (isUnauthenticatedRequest(response)) {
          this.props.onAppTokenAsked(true);
        } else {
          console.error(response, "GET COUNTRY ERROR");
        }
      })
      .catch((error) => {
        console.error(error, "GET COUNTRY ERROR");
      });
  }

  /**
   * Get schools schools based on selected country or continent
   *
   */
  onGetSchools() {
    const { countryCode } = this.props.match.params;
    console.log(countryCode);
    getCountrySchool(countryCode) // Filter schools based on the country code
      .then((response) => {
        if (!this.state.isUnmounted) {
          console.log(response, response.data);
          if (response) {
            this.props.onSetSchools(response);
            this.props.onPreloaderToggled(false, "");
          } else if (isUnauthenticatedRequest(response)) {
            this.props.onAppTokenAsked(true);
          } else {
            this.props.onPreloaderToggled(false, "");
            console.error(response, "GET SCHOOLS ERROR");
          }
        }
      })
      .catch((error) => {
        if (!this.state.isUnmounted) {
          this.props.onPreloaderToggled(false, "");
          console.error(error, "GET SCHOOLS ERROR");
        }
      });
  }

  onGetCountryArticles(code) {
    getCountryArticles(code)
      .then((res) => {
        let { item } = res;
        console.log("******************", item);
        this.setState({
          articles: item,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * Format tabs items.
   *
   * @returns
   */
  formatTabsItems() {
    if (this.props.country == null) return [];
    return COUNTRY_TABS.map((ctx) => ({
      ...ctx,
      content: this.props.country[ctx.key],
    }));
  }

  addUniversitytoFavorites(id) {
    try {
      console.log(this.state)
      let { userPublicId } = this.state;
      console.log("userId",userPublicId)
      addUniversityInStudentFavoriteList({
        publicId: userPublicId,
        universityPublicId: id,
      }).then((res) => {
        console.log(res);
      });
    } catch (err) {
      console.log(err);
    }
  }

    handleShareModalOpen = () => {
      
      console.log("open");
    this.setState({
      isShareModalOpen: true,
    });
  };

  handleShareModalClose(){
    console.log("closed");
    this.setState({
            isShareModalOpen: false,
          });
          return this.state.isShareModalOpen
  }

  render() {
    const { articles } = this.state;
    const { country, isPreloader, schools } = this.props;
    const filteredSchools = this.context || [];
    console.log(filteredSchools);

    return (
      <React.Fragment>
        <div id="country" className={`${isPreloader ? "d-none" : "d-block"}`}>
          <div id="">
            {/* Breadcrumbs */}
            <div className="container relative">
              <div className="row">
                <div className="col-lg-12 mt-16 mb-2">
                  {/* <Breadcrumbs
                    subtitle="Étudier en afrique"
                    currentTile={`Études ${country.name}`}
                  /> */}
                  <Breadcrumbs
                    subtitle={country?.continent}
                    currentTile={`Études ${country?.name}`}
                  />
                </div>
              </div>
            </div>

            {/* Banner, Leading */}
            <div className="container">
              <Banner bannerId="country-banner" withBackground={false}>
                <img
                  src={country_banner} //static banner
                  alt="#"
                  //   src={country.image}
                  //   alt={`Étudier au ${country.name}`}
                  className="w-full h-full object-corver"
                />

                <Leading
                  title={`Étudier au ${country.name}`}
                  subtitle="Informations, Ressources et Établissements"
                  leadingClasses="custom-leading"
                />
              </Banner>
            </div>

            {/* Tabs */}
            <div className="container">
              <Presentation />
            </div>

            {/* Pubs */}
            <div className="container mt-4">
              <img src={ads} alt="ads" className="w-full my-8" />
            </div>

            {/* Sliders */}
            {/* <Section
              title="Nos ambassadeurs dans ce pays"
              sectionId="country-slides"
              sectionInnerClasses="container mt-4 text-center"
              sectionClasses="country-article py-5 mt-2"
              textColor={"[#005073]"}
              // custom_style={'regular-font hide-pseudo'}
            >
              <div className="flex flex-col px-6">
                <div className="w-full relative">
                  <Sliders
                    slidersClasses="country-sliders"
                    responsiveOptions={SLIDERS_RESPONSIVES}
                    withDots={true}
                  >
                    {country.sliders ? (
                      country.sliders.map((item, index) => (
                        <div
                          key={`country_slider_item_${index}`}
                          className="box relative rounded-lg overflow-hidden"
                        >
                          <img
                            src={item.image}
                            alt={`country slider ${index}`}
                          />
                          <div className="overlay absolute bottom-0 left-0 p-4 w-full text-white">
                            <h4 className="text-lg mb-2">
                              <strong>consectetur Adipiscin</strong>
                            </h4>
                            <p>
                              Lorem ipsum dolor sit amet, consectetur adipiscing
                              elit.
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <></>
                    )}
                  </Sliders>
                </div>
              </div>
            </Section> */}
            <div className="container mt-4">
              {/* <img src={ads} alt="ads" className="w-full my-2" /> */}
            </div>
            {/* Country Articles */}
            <Section
              title="Nouvelles et articles"
              sectionId="country-articles"
              sectionClasses="country-article py-4 md:border-b-2 md:border-t-2 md:border-[#b9eb30] bg-[#005073] md:bg-inherit"
              sectionInnerClasses="container mt-4"
              textColor={"[#005073]"}
              custom_style={"text-center section_title hide-pseudo"}
            >
              <ArticlesCountry props={articles} publicId={country.publicId} />
            </Section>

            {/* Country Schools */}
            <Section
              title="Établissements du pays"
              sectionId="country-schools"
              sectionClasses="container py-5"
              sectionInnerClasses="mt-4"
              textColor={"#005073"}
              custom_style={"text-left section_title regular-font hide-pseudo"}
            >
              <FilterSchool
                listOfSchools={schools}
                favourites={this.addUniversitytoFavorites}
                opened={this.state.isShareModalOpen}
                onClosed={this.handleShareModalClose.bind(this)}
                handleModel={this.handleShareModalOpen.bind(this)}
              />
              {/* <ListSchool listerClasses="mt-3 flex md:flex-row flex-col wrap gap-4 p-4 justify-between list-school" items={ filteredSchools } /> */}
            </Section>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
Country.propTypes = {
  country: PropTypes.object,
  schools: PropTypes.array,
  onSetCountry: PropTypes.func,
  onSetSchools: PropTypes.func,
  isPreloader: PropTypes.bool,
  tokenFailed: PropTypes.bool,
  tokenRetrieved: PropTypes.bool,
  onAppTokenAsked: PropTypes.func,
  onAppTokenRetrieved: PropTypes.func,
  onPreloaderToggled: PropTypes.func,
};

const mapStateToProps = (state) => ({
  country: state.country,
  schools: state.schools,
  tokenRetrieved: state.tokenRetrieved,
  tokenFailed: state.tokenFailed,
  isPreloader: state.isPreloader,
});

const mapDispatchToProps = (dispatch) => ({
  onSetCountry: (data) => dispatch(setCountry(data)),
  onSetSchools: (data) => dispatch(setSchool(data)),
  onAppTokenAsked: (data) => dispatch(setAppTokenAsked(data)),
  onAppTokenRetrieved: (data) => dispatch(setAppTokenRetrieved(data)),
  onPreloaderToggled: (preload, message) =>
    dispatch(togglePreloader(preload, message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Country);
